<template>
  <b-container fluid class="pb-4">
    <h1 class="fc-h1">実績参照</h1>
    <form>
      <b-card class="w-50 mb-3">
        <form>
          <b-form-group
            id="serial"
            label-cols-sm="4"
            label-cols-lg="2"
            label="シリアル"
            label-for="input-horizontal"
          >
            <b-form-input v-model="serial" placeholder="シリアルを入力してください。"></b-form-input>
          </b-form-group>
          <b-form-group
            id="code"
            label-cols-sm="4"
            label-cols-lg="2"
            label="型番"
            label-for="input-horizontal"
          >
            <b-form-input v-model="code" placeholder="型番を入力してください。"></b-form-input>
          </b-form-group>
          <div>
            <b-button variant="primary" @click="search" class="float-right px-5">検索</b-button>
          </div>
        </form>
      </b-card>
    </form>
    <div v-if="isSearch">
      <b-card class="mb-3">
        <h2
          :class="showCollapse ? 'collapsed' : null"
          :aria-expanded="showCollapse ? 'true' : 'false'"
          aria-controls="collapse-12"
          @click="showCollapse = !showCollapse"
        >シリアル一覧</h2>
        <b-collapse id="collapse-12" v-model="showCollapse" class="mt-3">
          <b-table
            :striped="striped"
            :bordered="bordered"
            :borderless="borderless"
            :outlined="outlined"
            :current-page="currentPage"
            :small="small"
            :hover="hover"
            :dark="dark"
            :fixed="fixed"
            :foot-clone="footClone"
            :no-border-collapse="noCollapse"
            :items="serialItems"
            :fields="serialFields"
            :head-variant="headVariant"
            :table-variant="tableVariant"
          >
            <template v-slot:cell(serial)="row">
              <b-link
                @click="serialSearch()"
                :class="showCollapse ? 'collapsed' : null"
                :aria-expanded="showCollapse ? 'true' : 'false'"
                aria-controls="collapse-12"
              >{{ row.item.serial }}</b-link>
            </template>
          </b-table>
        </b-collapse>
      </b-card>
    </div>
    <div v-if="isSerial">
      <b-card>
        <h2>通過履歴情報</h2>
        <b-table
          :striped="striped"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :current-page="currentPage"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :no-border-collapse="noCollapse"
          :items="commonItems"
          :fields="commonFields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
          class="mt-3"
        >
          <template v-slot:cell(delete)="row">
            <b-button size="sm" class="mr-2" variant="danger" @click="issue">破棄</b-button>
          </template>
        </b-table>
        <b-table
          :striped="striped"
          :bordered="bordered"
          :borderless="borderless"
          :outlined="outlined"
          :current-page="currentPage"
          :small="small"
          :hover="hover"
          :dark="dark"
          :fixed="fixed"
          :foot-clone="footClone"
          :no-border-collapse="noCollapse"
          :items="processItems"
          :fields="processFields"
          :head-variant="headVariant"
          :table-variant="tableVariant"
        >
          <template v-slot:cell(edit)="row">
            <b-button size="sm" class="mr-2" @click="edit">編集</b-button>
          </template>
        </b-table>
        <div>
          <b-button variant="primary" @click="csv" class="float-right">CSV出力</b-button>
        </div>
      </b-card>
    </div>
    <confirm-modal msg="発行しました。" titleMsg="製品シリアル発行" buttonMsg="確認" @confirm="issueConfirm"/>
  </b-container>
</template>

<script>
export default {
  data () {
    return {
      selected: null,
      serial: '000001',
      code: null,
      note: null,
      currentPage: 1,
      serialFields: [
        { key: 'serial', label: 'シリアル' },
        { key: 'code', label: '型番' },
        { key: 'date', label: '通過日時' }
      ],
      commonFields: [
        { key: 'serial', label: 'シリアル' },
        { key: 'code', label: '型番' },
        { key: 'delete', label: '破棄' }
      ],
      processFields: [
        { key: 'line', label: 'ライン' },
        { key: 'process', label: '工程' },
        { key: 'machine', label: 'マシン' },
        { key: 'date', label: '通過日時' },
        { key: 'op', label: '担当者' },
        { key: 'okng', label: '判定' },
        { key: 'remarks', label: '備考' },
        { key: 'edit', label: '編集' }
      ],
      serialItems: [
        { serial: '000001', code: 'AAA', date: '2019/09/19 10:20:12' }
      ],
      commonItems: [{ serial: '000001', code: 'AAA' }],
      processItems: [
        {
          line: 'ライン1',
          process: '工程1',
          machine: '装置1',
          date: '2019/09/19 10:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程2',
          machine: '装置2',
          date: '2019/09/19 11:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程3',
          machine: '装置3',
          date: '2019/09/19 12:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程4',
          machine: '装置4',
          date: '2019/09/19 13:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程5',
          machine: '装置5',
          date: '2019/09/19 14:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程6',
          machine: '装置6',
          date: '2019/09/19 15:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程7',
          machine: '装置7',
          date: '2019/09/19 16:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程8',
          machine: '装置8',
          date: '2019/09/19 17:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程9',
          machine: '装置9',
          date: '2019/09/19 18:20:12',
          op: '市川 翔',
          okng: 'OK',
          remarks: ''
        },
        {
          line: 'ライン1',
          process: '工程10',
          machine: '装置10',
          date: '2019/09/19 19:20:12',
          op: '市川 翔',
          okng: 'NG',
          remarks: '傷あり'
        }
      ],
      tableVariants: [
        'primary',
        'secondary',
        'info',
        'danger',
        'warning',
        'success',
        'light',
        'dark'
      ],
      striped: true,
      bordered: true,
      borderless: true,
      outlined: false,
      small: false,
      hover: true,
      dark: true,
      fixed: true,
      footClone: false,
      headVariant: 'dark',
      tableVariant: '',
      showCollapse: false,
      noCollapse: true,
      isSearch: true,
      isSerial: true,
      from: '',
      to: ''
    }
  },
  methods: {
    search: function () {
      console.log(this.from)
      this.isSearch = true
      this.isSerial = false
      this.showCollapse = true
    },
    serialSearch: function () {
      this.isSerial = true
      this.showCollapse = false
    },
    edit: function () {
    },
    csv: function () {
    },
    issue: function () {
      this.$bvModal.show('md-confirm')
    },
    issueConfirm: function () {
      this.selected = null
      this.note = null
      this.qty = null
      this.$bvModal.hide('md-confirm')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/CalteFromOtherPage.vue